// Auto-generated subset of themes/Images.js: only the images that constants/category.ts uses.
// Importing the full barrel here would pull every PNG in the app into any bundle
// that touches these constants (see the registration app's bundle size work).
/* eslint-disable global-require */
const images = {
  icBodyTypeAthletic: require('../images/loginRegistration/icBodyTypeAthletic.png'),
  icBodyTypeAverage: require('../images/loginRegistration/icBodyTypeAverage.png'),
  icBodyTypeCuddly: require('../images/loginRegistration/icBodyTypeCuddly.png'),
  icBodyTypeLarge: require('../images/loginRegistration/icBodyTypeLarge.png'),
  icBodyTypeSlim: require('../images/loginRegistration/icBodyTypeSlim.png'),
  icBodyTypeThin: require('../images/loginRegistration/icBodyTypeThin.png'),
  icWhoCouple: require('../images/loginRegistration/icWhoCouple.png'),
  icWhoCoupleFF: require('../images/loginRegistration/icWhoCoupleFF.png'),
  icWhoCoupleMM: require('../images/loginRegistration/icWhoCoupleMM.png'),
  icWhoGroup: require('../images/loginRegistration/icWhoGroup.png'),
  icWhoMen: require('../images/loginRegistration/icWhoMen.png'),
  icWhoTVCD: require('../images/loginRegistration/icWhoTVCD.png'),
  icWhoTransMan: require('../images/loginRegistration/icWhoTransMan.png'),
  icWhoTransWoman: require('../images/loginRegistration/icWhoTransWoman.png'),
  icWhoWoman: require('../images/loginRegistration/icWhoWoman.png'),
};

export default images;
